import { ReportFetchResult, StatusCategory } from '@qality/common-model';
import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';
import { Utils } from '@qality/common-utils';

export default {
  async getReportCharts(
    filters: {
      name: string;
      value: string | number;
    }[]
  ) {
    const APIConstants = StorageOfUniqueServices.get('APIConstants');
    let params = '';

    if (filters) {
      params = filters
        .filter(Boolean)
        .filter(
          (filter) =>
            !(filter.name === 'projectId' && filter.value === 'ALL_PROJECTS')
        )
        .map((filter) => `&${filter.name}=${filter.value}`)
        .join('');
    }

    const AuthenticateService = StorageOfUniqueServices.get(
      'AuthenticateService'
    );
    const WindowOriginService = StorageOfUniqueServices.get(
      'WindowOriginService'
    );

    const url = await AuthenticateService.authenticateByJWT(
      WindowOriginService.origin +
        APIConstants.URL_TEST_EXECUTION_REPORT_CHARTS,
      params
    );

    const response = (await axios.get(encodeURI(url))).data;

    return response;
  },

  async getData(
    pageNumber: number,
    filters?: { [key: string]: string },
    size = 10,
    statusCategories?: StatusCategory[]
  ): Promise<ReportFetchResult> {
    const cleanFilters = Utils.removeEmptyStringValuesFromMap(filters);
    const filteredStatusCategories = statusCategories?.length
      ? statusCategories
      : undefined;
    const data = await getTestExecutions(
      pageNumber,
      size,
      cleanFilters,
      filteredStatusCategories
    );

    if (data.rows.content.length) {
      mapRows();
    }

    const report = new ReportFetchResult(
      {
        currentPage: data.rows.pageNumber,
        pageSize: data.rows.pageSize,
        totalElements: data.rows.totalElements,
        totalPages: data.rows.totalPages,
      },
      data
    );
    return report;

    function mapRows() {
      const testCaseColumnIndex = data.columnKeys.findIndex(
        ({ key }) => key === 'test_case'
      );

      data.rows.content = data.rows.content.map((row) => {
        row[testCaseColumnIndex].icon =
          StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();

        return row;
      });
    }
  },
};

const getTestExecutions = async (
  pageNumber: number,
  size: number,
  filters?: { [key: string]: string },
  statusCategories?: StatusCategory[]
) => {
  let params = `page=${pageNumber}&size=${size}`;

  if (statusCategories) {
    params += `&statusCategories=${statusCategories.join(',')}`;
  }

  if (filters) {
    Object.keys(filters).forEach((key) => {
      if (key === 'projectId') {
        if (filters[key] === 'ALL_PROJECTS') {
          return;
        }
      }
      if (key === 'startDate' || key === 'endDate') {
        if (filters[key] === 'none') {
          return;
        }
      }
      params += `&${key}=${filters[key]}`;
    });
  }

  const AuthenticateService = StorageOfUniqueServices.get(
    'AuthenticateService'
  );
  const WindowOriginService = StorageOfUniqueServices.get(
    'WindowOriginService'
  );
  const APIConstants = StorageOfUniqueServices.get('APIConstants');

  const url = await AuthenticateService.authenticateByJWT(
    WindowOriginService.origin + APIConstants.URL_TEST_EXECUTION_REPORT,
    params
  );

  const response = await axios.get(encodeURI(url));

  return response.data;
};
